export default "__VITE_ASSET__bc13d871__"